import type { PropsWithChildren } from 'react';
import { createContext, useMemo, useState } from 'react';

import { useEnsureContextWithinProvider } from './hooks/useEnsureContextWithinProvider';

interface ModalsDisplayedContext {
  commsBannerDisplayed: boolean;
  loginModalDisplayed: boolean;
  setCommsBannerDisplayed: (displayed: boolean) => void;
  setLoginModalDisplayed: (displayed: boolean) => void;
}

const ModalsDisplayedContext = createContext<ModalsDisplayedContext | null>(
  null
);

//commsBannerDisplayed, loginModalDisplayed
export const ModalsDisplayedProvider = ({ children }: PropsWithChildren) => {
  const [commsBannerDisplayed, setCommsBannerDisplayed] = useState(false);
  const [loginModalDisplayed, setLoginModalDisplayed] = useState(false);
  const context = useMemo(
    () => ({
      commsBannerDisplayed,
      setCommsBannerDisplayed,
      loginModalDisplayed,
      setLoginModalDisplayed,
    }),
    [
      commsBannerDisplayed,
      setCommsBannerDisplayed,
      loginModalDisplayed,
      setLoginModalDisplayed,
    ]
  );
  return (
    <ModalsDisplayedContext.Provider value={context}>
      {children}
    </ModalsDisplayedContext.Provider>
  );
};

export const useModalsDisplayedContext = () =>
  useEnsureContextWithinProvider(ModalsDisplayedContext, 'ModalsDisplayed');
